import React, { createContext, useState, useEffect } from "react";

// Create the Context
export const UserContext = createContext();

// Context Provider Component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  //  Load user from localStorage on app start
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Login User (Student / Tutor / Admin) — supports BOTH call styles
  // Style A (existing): loginUser(userData, token, role)
  // Style B (admin):    loginUser({ token, role:"admin", email, id, name })
  const loginUser = (arg1, arg2, arg3) => {
    // --- Style B: one object passed ---
    if (arg1 && typeof arg1 === "object" && arg1.token && arg1.role) {
      const formattedUser = {
        id: arg1.id || null,
        name: arg1.name || "Admin",
        email: arg1.email || null,
        role: arg1.role,
        token: arg1.token,
      };

      setUser(formattedUser);

      localStorage.setItem("user", JSON.stringify(formattedUser));
      localStorage.setItem("token", formattedUser.token);
      localStorage.setItem("authToken", formattedUser.token);
      localStorage.setItem("role", formattedUser.role);

      if (formattedUser.role === "tutor") {
        localStorage.setItem("tutor", JSON.stringify(formattedUser));
      }

      return;
    }

    // --- Style A: (userData, token, role) ---
    const userData = arg1;
    const token = arg2;
    const role = arg3;

    const formattedUser = {
      id: userData?.id || null,
      name: userData?.name || null,
      email: userData?.email || null,
      role,
      token,
    };

    setUser(formattedUser);

    localStorage.setItem("user", JSON.stringify(formattedUser));
    localStorage.setItem("token", token);
    localStorage.setItem("authToken", token);
    localStorage.setItem("role", role);

    if (role === "tutor") {
      localStorage.setItem("tutor", JSON.stringify(formattedUser));
    }
  };

  //  Logout User — Full Cleanup
  const logoutUser = () => {
    setUser(null);

    // Remove everything related to login
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("authToken");
    localStorage.removeItem("tutor");

    // 🔥 Extra cleanup for old system (if it existed)
    localStorage.removeItem("studentToken");
    localStorage.removeItem("studentInfo");
    localStorage.removeItem("tutorToken");
    localStorage.removeItem("tutorInfo");
  };

  return (
    <UserContext.Provider value={{ user, loginUser, logoutUser }}>
      {children}
    </UserContext.Provider>
  );
};
